export function parsePedidoIds(raw: string): { ids: number[]; invalid: string[] } {
  const tokens = raw
    .split(/[\n,]+/)
    .map(id => id.trim())
    .filter(id => id !== '')

  const ids: number[] = []
  const invalid: string[] = []

  tokens.forEach(token => {
    if (!/^\d+$/.test(token)) {
      invalid.push(token)
      return
    }

    const id = Number(token)
    if (!Number.isSafeInteger(id) || id <= 0) {
      invalid.push(token)
      return
    }

    ids.push(id)
  })

  return { ids, invalid }
}

export function buildFeGeneradaBody(userId: number, ids: number[]) {
  return {
    userId,
    orders: ids.map(orderId => ({
      orderId,
      searchType: 'id' as const
    }))
  }
}
